"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchCustomClaimSuccessF = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var actions_1 = require("../../constants/actions");
var auth_1 = require("firebase/auth");
var patchCustomClaimSuccessF = function () {
    var currentUser, refreshTokenResult;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!1) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.take)([actions_1.PATCH_CUSTOM_CLAIM_SUCCESS])];
            case 1:
                _a.sent();
                currentUser = (0, auth_1.getAuth)().currentUser;
                if (!currentUser) return [3 /*break*/, 4];
                return [4 /*yield*/, currentUser.getIdTokenResult(true)];
            case 2:
                refreshTokenResult = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'GET_CUSTOM_CLAIM_SUCCESS',
                        description: 'patchCustomClaimSuccessF',
                        requestValues: {},
                        successValues: {
                            item: refreshTokenResult.claims,
                        },
                    })];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
exports.patchCustomClaimSuccessF = patchCustomClaimSuccessF;
